import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router';
import { FULLSTACK_COURSE } from '../../../_utils/Routes';
import './C2wPromoBanner.css';

const SVGIcons = {
  Location: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  ),
  Calendar: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  Star: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
    </svg>
  ),
  Check: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  ),
  ArrowRight: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12"></line>
      <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
  ),
  DocText: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
  ),
  Users: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Gift: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"></polyline>
      <rect x="2" y="7" width="20" height="5"></rect>
      <line x1="12" y1="22" x2="12" y2="7"></line>
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
    </svg>
  ),
  LaurelShield: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  ShieldStar: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
      <polygon points="12 8 13.5 11 17 11.5 14.5 14 15 17.5 12 15.8 9 17.5 9.5 14 7 11.5 10.5 11 12 8"></polygon>
    </svg>
  ),
  Rocket: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.71.79-1.81.2-2.55L4.5 16.5z"></path>
      <path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-3.05 11a22.35 22.35 0 0 1-3.95 2z"></path>
    </svg>
  ),
  HtmlLogo: () => (
    <svg width="28" height="28" viewBox="0 0 512 512">
      <path fill="#E34F26" d="M71 460L30 0h452l-41 460L256 512z" />
      <path fill="#EF652A" d="M256 472l149-41 35-391H256z" />
      <path fill="#ECECEC" d="M256 176h-84l-6-64h174l6-64H102l18 192h136zM256 308l-68-18-4-50h-64l8 97 128 35z" />
      <path fill="#FFF" d="M256 176v-64h84l6-64H256v192h78l-7 78-71 19v66l128-35 17-192z" />
    </svg>
  ),
  CssLogo: () => (
    <svg width="28" height="28" viewBox="0 0 512 512">
      <path fill="#1572B6" d="M71 460L30 0h452l-41 460L256 512z" />
      <path fill="#33A9DC" d="M256 472l149-41 35-391H256z" />
      <path fill="#ECECEC" d="M256 208H166l-5-60h95V88H96l16 180h144zM256 356l-68-18-4-50h-60l9 104 123 33z" />
      <path fill="#FFF" d="M256 208v60h80l-8 84-72 19v62l123-33 17-192zM256 88v60h144l5-60z" />
    </svg>
  ),
  JsLogo: () => (
    <svg width="26" height="26" viewBox="0 0 512 512">
      <path fill="#F7DF1E" d="M0 0h512v512H0z" />
      <path fill="#000" d="M324.1 411.1c15.7 25.3 36.6 40.5 67 40.5 27.6 0 45.4-13.9 45.4-33 0-23-17.7-31.4-47.3-44.2l-16.3-7c-46.7-20-77.9-44.6-77.9-96.2 0-51.5 40.4-90 102.3-90 44.2 0 76.1 15.6 98.7 55.4l-46.6 29.8c-12.7-22.6-26.3-32.3-51.5-32.3-22.7 0-37.4 11.8-37.4 27.2 0 19 14.5 26.3 43.5 38.9l16.3 7c54.4 23.5 83.4 47.1 83.4 98.7 0 57.2-44.4 95.2-111.6 95.2-56.2 0-93.3-25.4-114-64.2l45-29.8zM170.8 414c11.8 20.9 27.2 36.3 54.4 36.3 22.7 0 37.2-9.1 37.2-38.1V227.1h61.7v188c0 62.6-35.4 90.7-93.4 90.7-47.2 0-78.9-23.6-96.1-62.6l36.2-29.2z" />
    </svg>
  ),
  ReactLogo: () => (
    <svg width="28" height="28" viewBox="-11.5 -10.23174 23 20.46348">
      <circle cx="0" cy="0" r="2.05" fill="#61DAFB" />
      <g stroke="#61DAFB" strokeWidth="1" fill="none">
        <ellipse rx="11" ry="4.2" />
        <ellipse rx="11" ry="4.2" transform="rotate(60)" />
        <ellipse rx="11" ry="4.2" transform="rotate(120)" />
      </g>
    </svg>
  ),
  SpringBootLogo: () => (
    <svg width="28" height="28" viewBox="0 0 128 128">
      <path fill="#6DB33F" d="M116.4 17.6C94.2-4.6 57.6-4.6 35.4 17.6c-17.7 17.7-21.7 44.5-12.2 66.2L3.6 103.4c-1.9 1.9-1.9 5 0 6.9l14.1 14.1c1.9 1.9 5 1.9 6.9 0l19.6-19.6c21.7 9.5 48.5 5.5 66.2-12.2 22.2-22.2 22.2-58.8 6-85zm-21.2 63.8c-13 13-33.5 14.4-48 3.2l39.1-39.1c1.9-1.9 1.9-5 0-6.9s-5-1.9-6.9 0L40.3 77.7c-11.2-14.5-9.8-35 3.2-48 14-14 36.8-14 50.8 0 14.1 14 14.1 36.8.9 51.7z" />
    </svg>
  ),
  SpringAiLogo: () => (
    <svg width="28" height="28" viewBox="0 0 128 128">
      <path fill="#6DB33F" d="M116.4 17.6C94.2-4.6 57.6-4.6 35.4 17.6c-17.7 17.7-21.7 44.5-12.2 66.2L3.6 103.4c-1.9 1.9-1.9 5 0 6.9l14.1 14.1c1.9 1.9 5 1.9 6.9 0l19.6-19.6c21.7 9.5 48.5 5.5 66.2-12.2 22.2-22.2 22.2-58.8 6-85zm-21.2 63.8c-13 13-33.5 14.4-48 3.2l39.1-39.1c1.9-1.9 1.9-5 0-6.9s-5-1.9-6.9 0L40.3 77.7c-11.2-14.5-9.8-35 3.2-48 14-14 36.8-14 50.8 0 14.1 14 14.1 36.8.9 51.7z" />
      <path fill="#FFA500" d="M102 36l3 9 9 3-9 3-3 9-3-9-9-3 9-3 3-9z" />
    </svg>
  ),
  MySqlLogo: () => (
    <svg width="28" height="28" viewBox="0 0 128 128">
      <path fill="#00758F" d="M105.8 45.4c-2.4-3.5-6.5-6.2-10.8-7.6-1.5-.5-3.1-.8-4.7-1-1.1-.1-2.2-.1-3.3 0-2.4.3-4.7 1.2-6.7 2.5-3.9 2.6-6.7 6.6-8.2 11-1.1 3.2-1.4 6.7-1 10.1.5 3.7 1.9 7.2 4 10.2 3.1 4.5 7.6 7.9 12.8 9.7 2.1.7 4.3 1.1 6.5 1.1 3.4 0 6.7-.9 9.6-2.6 4.3-2.5 7.5-6.5 9.3-11.1 1.4-3.6 1.7-7.5 1.1-11.3-.7-4-2.5-7.7-5.3-10.6-1-1-2.2-1.9-3.3-2.6v.2zm-12.7 26.2c-4.2.8-8.6-.8-11.3-4.1-2.7-3.3-3.2-8-.1-11.8 3.1-3.8 8.4-5 12.8-2.9 4.4 2.1 6.9 7 6 11.8-.8 4.3-4.2 7.2-7.4 7z" />
      <path fill="#F29111" d="M48.2 40.5c-4.7.2-9.2 2.1-12.7 5.3-4.3 4-6.8 9.7-7 15.6-.2 5.5 1.7 11 5.3 15.2 4 4.6 9.8 7.3 15.9 7.4 5.2.1 10.3-1.8 14.3-5.2 4.4-3.8 7.2-9.3 7.8-15.1.6-5.8-1-11.6-4.5-16-3.8-4.7-9.3-7.4-15.3-7.6-1.3-.1-2.6 0-3.8.4zM49.6 75c-4.1 0-7.9-2.2-10-5.8-2.1-3.6-2.1-8.1 0-11.7 2.1-3.6 5.9-5.8 10-5.8 4.1 0 7.9 2.2 10 5.8 2.1 3.6 2.1 8.1 0 11.7-2.1 3.6-5.9 5.8-10 5.8z" />
    </svg>
  )
};

const techBadgesList = [
  { name: 'HTML', color: '#e34f26', bg: 'rgba(227, 79, 38, 0.15)', imgSrc: null, Component: SVGIcons.HtmlLogo },
  { name: 'CSS', color: '#1572b6', bg: 'rgba(21, 114, 182, 0.15)', imgSrc: null, Component: SVGIcons.CssLogo },
  { name: 'JavaScript', color: '#f7df1e', bg: 'rgba(247, 223, 30, 0.15)', imgSrc: '/assets/images/landing/jsSvg.svg', Component: SVGIcons.JsLogo },
  { name: 'React', color: '#00d8ff', bg: 'rgba(0, 216, 255, 0.15)', imgSrc: '/assets/images/landing/reactLogoSvg.svg', Component: SVGIcons.ReactLogo },
  { name: 'Spring Boot', color: '#6db33f', bg: 'rgba(109, 179, 63, 0.15)', imgSrc: '/assets/images/landing/springLogoSvg.svg', Component: SVGIcons.SpringBootLogo },
  { name: 'Spring AI', color: '#00e676', bg: 'rgba(0, 230, 118, 0.15)', imgSrc: '/assets/full%20stack/spring%20ai.png', Component: SVGIcons.SpringAiLogo },
  { name: 'MySQL', color: '#00758f', bg: 'rgba(0, 117, 143, 0.15)', imgSrc: '/assets/images/landing/dbmsLogoSvg.svg', Component: SVGIcons.MySqlLogo },
];

const C2wPromoBanner = ({ onClose }) => {
  const navigate = useNavigate();
  const overlayRef = React.useRef(null);

  React.useEffect(() => {
    const scroller = document.querySelector('.C2wAdHome_index');
    if (!scroller) return;

    let touchStart = 0;

    const handleWheel = (e) => {
      scroller.scrollTop += e.deltaY;
    };

    const handleTouchStart = (e) => {
      if (e.touches.length > 0) {
        touchStart = e.touches[0].clientY;
      }
    };

    const handleTouchMove = (e) => {
      if (e.touches.length > 0) {
        const touchCurrent = e.touches[0].clientY;
        const deltaY = touchStart - touchCurrent;
        scroller.scrollTop += deltaY;
        touchStart = touchCurrent;
      }
    };

    const overlay = overlayRef.current;
    if (overlay) {
      overlay.addEventListener('wheel', handleWheel, { passive: true });
      overlay.addEventListener('touchstart', handleTouchStart, { passive: true });
      overlay.addEventListener('touchmove', handleTouchMove, { passive: true });
    }

    return () => {
      if (overlay) {
        overlay.removeEventListener('wheel', handleWheel);
        overlay.removeEventListener('touchstart', handleTouchStart);
        overlay.removeEventListener('touchmove', handleTouchMove);
      }
    };
  }, []);

  return (
    <div ref={overlayRef} className="promo-banner-overlay" onClick={onClose}>
      <motion.div
        className="promo-banner-container promo-fullstack-theme"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="promo-close-btn" onClick={onClose}>&times;</button>

        {/* Decorative background grid and glowing lights */}
        <div className="promo-bg-decorations">
          <div className="promo-grid-dots left"></div>
          <div className="promo-grid-dots right"></div>
          <div className="promo-glow-green"></div>
          <div className="promo-glow-cyan"></div>
          <span className="promo-shape-plus x1">+</span>
          <span className="promo-shape-cross x2">x</span>
          <span className="promo-shape-plus x3">+</span>
          <span className="promo-shape-cross x4">x</span>
        </div>

        <div className="promo-banner-content">
          {/* Main sections grid */}
          <div className="promo-main-grid">
            {/* Left Section */}
            <motion.div
              className="promo-section-left"
              initial={{ opacity: 0, x: -35 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.15, duration: 0.6, ease: "easeOut" }}
            >
              <div className="promo-date-row">
                <span className="promo-pill-offline">
                  <SVGIcons.Location /> Offline Course
                </span>
                <span className="promo-pill-upcoming">
                  <SVGIcons.Calendar /> Upcoming
                </span>
              </div>

              <h1 className="promo-title-java promo-title-fullstack">
                <span className="fsp-text-gradient">Java Full Stack Development</span>{' '}
                <span className="fsp-with-text">With</span>{' '}
                <span className="fsp-placement-highlight-animated">
                  Placement Assistance
                </span>
              </h1>

              {/* Tech Stack Icons Row */}
              <div className="promo-tech-stack-row">
                {techBadgesList.map((t, idx) => {
                  const LogoComp = t.Component;
                  return (
                    <div key={idx} className="promo-tech-badge-item">
                      <div className="promo-tech-icon-box" style={{ borderColor: t.color, background: t.bg }}>
                        {t.imgSrc ? (
                          <img
                            src={t.imgSrc}
                            alt={t.name}
                            style={{ width: '28px', height: '28px', objectFit: 'contain' }}
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                          />
                        ) : (
                          <LogoComp />
                        )}
                      </div>
                      <span className="promo-tech-label">{t.name}</span>
                    </div>
                  );
                })}
              </div>

              {/* Glowing Combo Pill (React + Spring Boot + Spring AI) */}
              <div className="promo-combo-pill-bar">
                <div className="combo-item">
                  <img src="/assets/images/landing/reactLogoSvg.svg" alt="React" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                  <span className="react-cyan">React</span>
                </div>
                <span className="plus-sign">+</span>
                <div className="combo-item">
                  <img src="/assets/images/landing/springLogoSvg.svg" alt="spring boot" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                  <span className="spring-green">spring boot</span>
                </div>
                <span className="plus-sign">+</span>
                <div className="combo-item">
                  <img src="/assets/full%20stack/spring%20ai.png" alt="Spring AI" style={{ width: '22px', height: '22px', objectFit: 'contain' }} />
                  <span className="ai-emerald">Spring AI</span>
                </div>
              </div>

              {/* Two Column Capsule Pill */}
              <div className="promo-two-col-capsule">
                <div className="promo-capsule-col">
                  <div className="promo-capsule-icon">
                    <SVGIcons.DocText />
                  </div>
                  <div className="promo-capsule-text">
                    <strong className="green-title">INTERNSHIP</strong>
                    <span className="gray-sub">will be provided</span>
                  </div>
                </div>
                <div className="promo-capsule-divider"></div>
                <div className="promo-capsule-col">
                  <div className="promo-capsule-icon">
                    <SVGIcons.Users />
                  </div>
                  <div className="promo-capsule-text">
                    <strong className="green-title">NO PREREQUISITES</strong>
                    <span className="gray-sub">Any Student can join the batch</span>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Center Section: Program Highlights Card */}
            <motion.div
              className="promo-section-center"
              initial={{ opacity: 0, y: 35 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.25, duration: 0.6, ease: "easeOut" }}
            >
              <div className="promo-highlights-card promo-highlights-green">
                <div className="promo-card-header">
                  <div className="promo-card-header-inner">
                    <div className="promo-star-container">
                      <SVGIcons.Star />
                    </div>
                    <span>PROGRAM HIGHLIGHTS</span>
                  </div>
                </div>

                <ul className="promo-highlights-list">
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>React 19 & Tailwind css</strong>
                      <span>Components, Hooks, State & Modern UI</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>Enterprise Spring Boot & Microservices</strong>
                      <span>REST APIs, Spring Security, Hibernate</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>Spring AI & LLM Applications</strong>
                      <span>Generative AI, OpenAI & Vector DBs</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>18+ Real-World Enterprise Projects</strong>
                      <span>E-Commerce, Delivery & SaaS Platforms</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>2000+ Quiz</strong>
                      <span>Intensive Hands-on Practice & Assessment</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>Offline Mock Interviews & Placement Assistance</strong>
                      <span>Resume Building & Placement Prep</span>
                    </div>
                  </li>
                  <li>
                    <div className="promo-tick-circle green">
                      <SVGIcons.Check />
                    </div>
                    <div className="promo-highlight-detail">
                      <strong>20+ Mentors & Team Leads</strong>
                      <span>Personalized 1-on-1 Mentorship & Guidance</span>
                    </div>
                  </li>
                </ul>

                {/* Gift promo box inside highlights card */}
                <div className="promo-gift-box green">
                  <div className="promo-gift-icon">
                    <SVGIcons.Gift />
                  </div>
                  <div className="promo-gift-text">
                    <strong>Learn. Build. Get Certified.</strong>
                    <span>Master Enterprise Full Stack Development with Spring AI.</span>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right Section: Shashi Sir + Fees */}
            <div className="promo-section-right">
              {/* Decorative circle arcs behind Shashi Sir */}
              <div className="promo-sir-arch-bg green"></div>

              <motion.div
                className="promo-sir-photo-wrapper"
                initial={{ opacity: 0, scale: 0.9, y: 40 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.7, ease: "easeOut" }}
              >
                <img
                  src="/assets/images/landing/ShashiSir-min.png"
                  alt="Shashi Sir"
                  className="promo-sir-photo"
                />
              </motion.div>

              {/* Fees and Enroll Card */}
              <motion.div
                className="promo-fees-card green"
                initial={{ opacity: 0, y: 35 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
              >
                <div className="promo-fees-badge green">FEES</div>
                <div className="promo-fees-amount">
                  <span className="price">₹17,000</span>
                  <span className="gst">+ 18% GST</span>
                </div>
                <button
                  className="promo-enroll-button green"
                  onClick={() => {
                    onClose();
                    navigate(FULLSTACK_COURSE);
                  }}
                >
                  <span>ENROLL NOW!</span>
                  <div className="promo-enroll-arrow-circle">
                    <SVGIcons.ArrowRight />
                  </div>
                </button>
              </motion.div>
            </div>
          </div>

          {/* Bottom Row: Certifications White Capsule */}
          <motion.div
            className="promo-bottom-row"
            initial={{ opacity: 0, y: 25 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.6, ease: "easeOut" }}
          >
            <div className="promo-cert-capsule">
              {/* Certifications Header */}
              <div className="promo-cert-item title-section">
                <div className="promo-cert-icon green-laurel">
                  <SVGIcons.LaurelShield />
                </div>
                <span className="promo-cert-title-text">CERTIFICATIONS</span>
              </div>

              <div className="promo-cert-divider"></div>

              {/* E-Certificate */}
              <div className="promo-cert-item">
                <div className="promo-cert-icon doc-blue">
                  <SVGIcons.DocText />
                </div>
                <div className="promo-cert-text">
                  <strong>FullStack Certification</strong>
                  <span>upon successful completion</span>
                </div>
              </div>

              <div className="promo-cert-divider"></div>

              {/* SuperX Certification */}
              <div className="promo-cert-item">
                <div className="promo-cert-icon star-orange">
                  <SVGIcons.ShieldStar />
                </div>
                <div className="promo-cert-text">
                  <strong>SuperX Certification</strong>
                  <span>awarded on completion of SuperX project</span>
                </div>
              </div>

              <div className="promo-cert-divider"></div>

              {/* Your Future. Our Mission. */}
              <div className="promo-cert-item text-green">
                <div className="promo-cert-icon rocket-green">
                  <SVGIcons.Rocket />
                </div>
                <div className="promo-cert-text">
                  <strong className="highlight-green-bold">Your Future. Our Mission.</strong>
                  <span className="highlight-green-sub">Get Trained. Get Certified. Get Hired.</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default C2wPromoBanner;
